import { render, staticRenderFns } from "./changeVerDialog.vue?vue&type=template&id=40da56ca&"
import script from "./changeVerDialog.vue?vue&type=script&lang=js&"
export * from "./changeVerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports